import React from 'react';
import Icon from '../../../components/AppIcon';

const PricingSection = () => {
  return (
    <section className="py-24 relative overflow-hidden" style={{background: '#0f1f3d'}}>
      {/* Background texture */}
      <div className="absolute inset-0 opacity-[0.03]" style={{backgroundImage: 'linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)', backgroundSize: '40px 40px'}}></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-widest" style={{background: 'rgba(45,212,191,0.15)', color: '#2dd4bf', border: '1px solid rgba(45,212,191,0.3)'}}>
            <Icon name="Tag" size={14} />
            Pricing
          </div>
          <h2 className="font-heading font-bold text-white leading-tight mb-5" style={{fontSize: 'clamp(2rem, 4vw, 3rem)'}}>
            Pricing that doesn't break the bank
          </h2>
        </div>

        {/* Single centered pricing card */}
        <div className="flex justify-center">
          <div className="w-full max-w-sm rounded-3xl p-8 flex flex-col items-center text-center relative overflow-hidden" style={{background: 'linear-gradient(160deg, #2dd4bf 0%, #0d9488 100%)'}}>
            <div className="absolute -bottom-8 -right-8 w-40 h-40 rounded-full opacity-20" style={{background: '#fff'}}></div>
            <div className="relative z-10 w-full">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 mx-auto" style={{background: 'rgba(255,255,255,0.2)'}}>
                <Icon name="DollarSign" size={28} className="text-white" />
              </div>
              <div className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-bold mb-5" style={{background: 'rgba(255,255,255,0.2)', color: '#fff'}}>
                🎉 7-Day Free Trial
              </div>
              <h3 className="font-heading font-bold text-white text-4xl mb-2">$7.99</h3>
              <p className="text-sm font-semibold mb-1" style={{color: 'rgba(255,255,255,0.85)'}}>per month</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;